module.exports = __webpack_public_path__ + "static/media/joker.3e27a25f.png";